import OciDocsFeature from '../../features/docs/oci-feature';

export default function OciDocsPage() {
  return <OciDocsFeature />;
}
